module.exports = __webpack_public_path__ + "img/erweima.2bf8203c.jpg";